var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoFinalizado(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 11.83 11.83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_3",
    "data-name": "Capa 3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.06,5.92l3.32-3.32c.59-.59.59-1.55,0-2.15-.59-.59-1.55-.59-2.15,0l-3.32,3.32L2.59.44C2-.15,1.04-.15.44.44-.15,1.04-.15,2,.44,2.59l3.32,3.32L.44,9.24c-.59.59-.59,1.55,0,2.15.3.3.69.44,1.07.44s.78-.15,1.07-.44l3.32-3.32,3.32,3.32c.3.3.69.44,1.07.44s.78-.15,1.07-.44c.59-.59.59-1.55,0-2.15l-3.32-3.32Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoFinalizado);
export default __webpack_public_path__ + "static/media/NoFinalizado.686e2972b5896ac4b4b7a2c673ec30a3.svg";
export { ForwardRef as ReactComponent };